import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-sign-in-step-register',
  templateUrl: './sign-in-step-register.component.html',
  styleUrls: ['./sign-in-step-register.component.scss'],
})
export class SignInStepRegisterComponent implements OnInit, OnDestroy {
  @Input() registerForm!: FormGroup;
  @Input() showPassword = false;
  @Input() hasMinLength = false;
  @Input() hasUpperCase = false;
  @Input() hasLowerCase = false;
  @Input() hasNumber = false;
  /** true cuando el step se precargó desde Google/Facebook: oculta el password. */
  @Input() isSocialSignup = false;
  /** true cuando el email ya tiene cuenta (flujo manual): muestra aviso de login. */
  @Input() emailAlreadyExists = false;
  /** true mientras se consulta si el email ya existe. */
  @Input() checkingEmail = false;

  @Output() goToStep = new EventEmitter<number>();
  @Output() continueClicked = new EventEmitter<void>();
  @Output() togglePasswordVisibility = new EventEmitter<void>();
  @Output() goToLegal = new EventEmitter<void>();
  @Output() openLoginModal = new EventEmitter<void>();
  @Output() firstStepValidateChange = new EventEmitter<boolean>();

  private statusChangesSub: any;

  constructor(private cdr: ChangeDetectorRef) {}

  get canContinue(): boolean {
    if (!this.registerForm) return false;
    const firstName = this.registerForm.get('first_name')?.valid;
    const lastName = this.registerForm.get('last_name')?.valid;
    const email = this.registerForm.get('email')?.valid;
    const pass = this.isSocialSignup || this.registerForm.get('password')?.valid;
    return !!(firstName && lastName && email && pass);
  }

  ngOnInit(): void {
    if (this.registerForm) {
      this.statusChangesSub = this.registerForm.statusChanges.subscribe(() => {
        this.cdr.markForCheck();
      });
    }
  }

  ngOnDestroy(): void {
    this.statusChangesSub?.unsubscribe();
  }
}
